module.exports = __webpack_public_path__ + "static/media/vmove_logo_v_orange.1a38d164.jpg";